import React from 'react';
import '../styles/Loader.css';
import Logo from '../images/shop_logo.png';

function Loader({ text }) {
  return (
    <div className="preloader align-center justify-center">
      <div className="loader-ring-container">
        {/* Static Ring */}
        <div className="loader-ring"></div>
        
        {/* Orbiting Dot */}
        <div className="loader-orbit"></div>
        
        {/* Pulsating Logo */}
        <div className="loader-logo">
          {/* Replace with your actual logo path */}
          <img src={Logo} alt="Company Logo" />
        </div>
      </div>
      <p className="loader-text">{text}</p>
    </div>
  );
}

export default Loader;